import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-user-line',
      title: t('services.individual.title'),
      description: t('services.individual.desc'),
      features: [
        t('services.individual.feature1'),
        t('services.individual.feature2'),
        t('services.individual.feature3')
      ]
    },
    {
      icon: 'ri-file-text-line',
      title: t('services.tax.title'),
      description: t('services.tax.desc'),
      features: [
        t('services.tax.feature1'),
        t('services.tax.feature2'),
        t('services.tax.feature3')
      ]
    },
    {
      icon: 'ri-line-chart-line',
      title: t('services.planning.title'),
      description: t('services.planning.desc'),
      features: [
        t('services.planning.feature1'),
        t('services.planning.feature2'),
        t('services.planning.feature3')
      ]
    },
    {
      icon: 'ri-building-line',
      title: t('services.patronage.title'),
      description: t('services.patronage.desc'),
      features: [
        t('services.patronage.feature1'),
        t('services.patronage.feature2'),
        t('services.patronage.feature3')
      ]
    },
    {
      icon: 'ri-shield-check-line',
      title: t('services.irs.title'),
      description: t('services.irs.desc'),
      features: [
        t('services.irs.feature1'),
        t('services.irs.feature2'),
        t('services.irs.feature3')
      ]
    },
    {
      icon: 'ri-briefcase-line',
      title: t('services.business.title'),
      description: t('services.business.desc'),
      features: [
        t('services.business.feature1'),
        t('services.business.feature2'),
        t('services.business.feature3')
      ]
    },
    {
      icon: 'ri-calculator-line',
      title: t('services.accounting.title'),
      description: t('services.accounting.desc'),
      features: [
        t('services.accounting.feature1'),
        t('services.accounting.feature2'),
        t('services.accounting.feature3')
      ]
    },
    {
      icon: 'ri-shield-user-line',
      title: t('services.welfare.title'),
      description: t('services.welfare.desc'),
      features: [
        t('services.welfare.feature1'),
        t('services.welfare.feature2'),
        t('services.welfare.feature3')
      ]
    },
    {
      icon: 'ri-file-list-3-line',
      title: t('services.caf.title'),
      description: t('services.caf.desc'),
      features: [
        t('services.caf.feature1'),
        t('services.caf.feature2'),
      ]
    },
    {
      icon: 'ri-global-line',
      title: t('services.immigration.title'),
      description: t('services.immigration.desc'),
      features: [
        t('services.immigration.feature1'),
        t('services.immigration.feature2'),
      ]
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-orange-500 font-bold"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
